import React from 'react';
import theme from 'configShared/theme/light';
import { TTheme } from 'appTypes/theme';

export const ContextTheme = React.createContext<TTheme>(theme);

export default {
  ContextTheme,
};
